export const globalSettingsSystemLexorankRoute = {
	name: 'global-settings-system-lexorank',
	path: '/secure/GHLexoRankManage.jspa',
	query: ['decorator=admin'],
};
